/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as QueueDefs from './defs.defs.js'

const $nsid = 'tools.ozone.queue.createQueue'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  name: /*#__PURE__*/ l.string(),
  subjectTypes: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.string<{
        knownValues: ['account', 'record', 'message', 'conversation']
      }>(),
    ),
  ),
  collection: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'nsid' }),
  ),
  reportTypes: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string(), { maxLength: 25 }),
  ),
  description: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  recommendedPolicies: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  queue: /*#__PURE__*/ l.ref<QueueDefs.QueueView>(
    (() => QueueDefs.queueView) as any,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Create a new moderation queue. A queue can have optional matching criteria that ozone's queue router will use to match reports. A queue with no criteria must have reports assigned to it manually via (1) `modTool.meta.queueId` in `tools.ozone.moderation.emitEvent` or (2) `tools.ozone.report.reassignQueue`. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'InvalidRecommendedPolicies',
  'ConflictingQueue',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
